import { ProtectedRoute } from "@/components/ProtectedRoute";

const RoutesUserGoon = [
  {
    path: "/home",
    lazy: async () => {
      const { default: Home } = await import("@/pages/UserGoOn/Home/Home");
      return { element: <Home /> };
    },
  },
  {
    path: "/toast-preview",
    lazy: async () => {
      const { default: ToastPreview } =
        await import("@/pages/UserGoOn/ToastPreview/ToastPreview");
      return { element: <ToastPreview /> };
    },
  },
  {
    path: "/overview",
    lazy: async () => {
      const { default: NewOverview } =
        await import("@/pages/UserGoOn/Overviews");
      return {
        element: (
          <ProtectedRoute recurso="overview" permissao="visualizar">
            <NewOverview />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/overview/jornadas/nova",
    lazy: async () => {
      const { default: CriarJornadaOverview } =
        await import("@/pages/UserGoOn/JornadasCustomizaveis/CriarJornadaOverview");
      const { JornadaConfigurationRoute } =
        await import("@/pages/UserGoOn/JornadasCustomizaveis/JornadaConfigurationRoute");
      return {
        element: (
          <JornadaConfigurationRoute>
            <CriarJornadaOverview />
          </JornadaConfigurationRoute>
        ),
      };
    },
  },
  {
    path: "/overview/jornadas",
    lazy: async () => {
      const { default: JornadasCustomizaveis } =
        await import("@/pages/UserGoOn/JornadasCustomizaveis");
      return {
        element: (
          <ProtectedRoute recurso="jornadas" permissao="visualizar">
            <JornadasCustomizaveis />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/overview/:idCampanha",
    lazy: async () => {
      const { default: NewOverview } =
        await import("@/pages/UserGoOn/Overviews");
      return {
        element: (
          <ProtectedRoute recurso="overview" permissao="visualizar">
            <NewOverview />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/admin",
    lazy: async () => {
      const { AdminDashboard } =
        await import("@/pages/UserGoOn/AdminDashboard/AdminDashboard");
      return {
        element: (
          <ProtectedRoute recurso="admin-dashboard" permissao="visualizar">
            <AdminDashboard />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/task-score",
    lazy: async () => {
      const { TaskScore } = await import("@/pages/UserGoOn/TaskScore");
      return {
        element: (
          <ProtectedRoute recurso="task-score" permissao="visualizar">
            <TaskScore />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/admin/saude",
    lazy: async () => {
      const { SaudeDoSistema } =
        await import("@/pages/UserGoOn/Admin/SaudeDoSistema");
      return {
        element: (
          <ProtectedRoute recurso="admin-saude" permissao="visualizar">
            <SaudeDoSistema />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/monitoramento",
    lazy: async () => {
      const { Monitoramento } =
        await import("@/pages/UserGoOn/Monitoramento/Monitoramento");
      return { element: <Monitoramento /> };
    },
  },
  {
    path: "/feedback",
    lazy: async () => {
      const { FeedbackPage } =
        await import("@/pages/UserGoOn/Feedback/FeedbackPage");
      return { element: <FeedbackPage /> };
    },
  },
  {
    path: "/feedback/:id",
    lazy: async () => {
      const { FeedbackPage } =
        await import("@/pages/UserGoOn/Feedback/FeedbackPage");
      return { element: <FeedbackPage /> };
    },
  },
  {
    path: "/admin/feedback",
    lazy: async () => {
      const { FeedbackPage } =
        await import("@/pages/UserGoOn/Feedback/FeedbackPage");
      return { element: <FeedbackPage /> };
    },
  },
  {
    path: "/admin/feedback/:id",
    lazy: async () => {
      const { FeedbackPage } =
        await import("@/pages/UserGoOn/Feedback/FeedbackPage");
      return { element: <FeedbackPage /> };
    },
  },
  {
    path: "/organizacoes",
    lazy: async () => {
      const { default: Organizacoes } =
        await import("@/pages/UserGoOn/Organizacoes");
      return {
        element: (
          <ProtectedRoute recurso="organizacoes" permissao="visualizar">
            <Organizacoes />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/usuarios",
    lazy: async () => {
      const { default: Usuarios } = await import("@/pages/UserGoOn/UsersNew");
      return { element: <Usuarios /> };
    },
  },
  {
    path: "/usuarios/novo",
    lazy: async () => {
      const { UsuariosFormPage } =
        await import("@/pages/UserGoOn/UsersNew/form/FormPage");
      return {
        element: (
          <ProtectedRoute recurso="usuarios" permissao="criar">
            <UsuariosFormPage />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/usuarios/editar/:id",
    lazy: async () => {
      const { UsuariosFormPage } =
        await import("@/pages/UserGoOn/UsersNew/form/FormPage");
      return {
        element: (
          <ProtectedRoute recurso="usuarios" permissao="editar">
            <UsuariosFormPage />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/perfil-empresa",
    lazy: async () => {
      const { default: CompanyProfileEditor } =
        await import("@/pages/AdLink/CompanyProfile/CompanyProfileEditor");
      return {
        element: (
          <ProtectedRoute recurso="empresas" permissao="editar">
            <CompanyProfileEditor />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/dashboard",
    lazy: async () => {
      const { default: PageDashboard } =
        await import("@/pages/UserGoOn/Dashboard");
      return {
        element: (
          <ProtectedRoute recurso="dashboard" permissao="visualizar">
            <PageDashboard />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/dashboard/:hash/:pi",
    lazy: async () => {
      const { default: DashboardNoLogin } =
        await import("@/pages/UserLoggedOut/DashboardNoLogin");
      return { element: <DashboardNoLogin /> };
    },
  },
  {
    path: "/agencias",
    lazy: async () => {
      const { default: Agencias } = await import("@/pages/UserGoOn/Agencias");
      return {
        element: (
          <ProtectedRoute recurso="agencias" permissao="visualizar">
            <Agencias />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/agencias/produtos",
    lazy: async () => {
      const { default: SelectProduto } =
        await import("@/pages/UserGoOn/Agencias/SelectProduto");
      return {
        element: (
          <ProtectedRoute recurso="agencias" permissao="visualizar">
            <SelectProduto />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/agencias/produtos/ads",
    lazy: async () => {
      const { default: TabelaAds } =
        await import("@/pages/UserGoOn/Agencias/TabelaAds");
      return {
        element: (
          <ProtectedRoute recurso="agencias" permissao="visualizar">
            <TabelaAds />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/agencias/produtos/representacao",
    lazy: async () => {
      const { default: TabelaRepresentacao } =
        await import("@/pages/UserGoOn/Agencias/TabelaRepresentacao");
      return {
        element: (
          <ProtectedRoute recurso="agencias" permissao="visualizar">
            <TabelaRepresentacao />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/desks/download/:id",
    lazy: async () => {
      const { default: RotaDownloadPDF } =
        await import("@/pages/UserGoOn/Desks/components/Representaacao/RotaDownloadPDF");
      return { element: <RotaDownloadPDF /> };
    },
  },
  {
    path: "/desks",
    lazy: async () => {
      const { default: HomeListDesk } =
        await import("@/pages/UserGoOn/Desks/HomeListDesk");
      return {
        element: (
          <ProtectedRoute recurso="desks" permissao="visualizar">
            <HomeListDesk />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/painel-producao/ocupacao-produtores",
    lazy: async () => {
      const { default: OcupacaoProdutores } =
        await import("@/pages/UserGoOn/PainelProducao/OcupacaoProdutores");
      return {
        element: (
          <ProtectedRoute recurso="desks" permissao="visualizar">
            <OcupacaoProdutores />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/desks/:deskId",
    lazy: async () => {
      const { default: VisualizarDeskRoute } =
        await import("@/pages/UserGoOn/Desks/VisualizarDeskRoute");
      return {
        element: (
          <ProtectedRoute recurso="desks" permissao="visualizar">
            <VisualizarDeskRoute />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/desk/:deskId",
    lazy: async () => {
      const { default: VisualizarDeskRoute } =
        await import("@/pages/UserGoOn/Desks/VisualizarDeskRoute");
      return {
        element: (
          <ProtectedRoute recurso="desks" permissao="visualizar">
            <VisualizarDeskRoute />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/clientes",
    lazy: async () => {
      const { default: Clientes } = await import("@/pages/UserGoOn/Cliente");
      return {
        element: (
          <ProtectedRoute recurso="clientes" permissao="visualizar">
            <Clientes />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/contatos",
    lazy: async () => {
      const { default: ListContatos } =
        await import("@/pages/UserGoOn/Contatos/HomeContatos");
      return {
        element: (
          <ProtectedRoute recurso="contatos" permissao="visualizar">
            <ListContatos />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/ad-link/usuarios",
    lazy: async () => {
      const { default: AdLinkUsers } =
        await import("@/pages/UserGoOn/AdLinkUsers");
      return {
        element: (
          <ProtectedRoute recurso="ad-link-users" permissao="visualizar">
            <AdLinkUsers />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/contatos/adicionar",
    lazy: async () => {
      const { default: CadastrarContato } =
        await import("@/pages/UserGoOn/Contatos/CadastrarContato");
      return {
        element: (
          <ProtectedRoute recurso="contatos" permissao="criar">
            <CadastrarContato />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/produtos",
    lazy: async () => {
      const { default: Produtos } = await import("@/pages/UserGoOn/Projetos");
      return {
        element: (
          <ProtectedRoute recurso="produtos" permissao="visualizar">
            <Produtos />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/produtos/ads",
    lazy: async () => {
      const { default: TabelaProdutosAds } =
        await import("@/pages/UserGoOn/Projetos/Ads");
      return {
        element: (
          <ProtectedRoute recurso="produtos" permissao="visualizar">
            <TabelaProdutosAds />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/produtos/representacao",
    lazy: async () => {
      const { default: PropostaRepresentacao } =
        await import("@/pages/UserGoOn/Representado/components/Projetos/Representacao");
      return {
        element: (
          <ProtectedRoute recurso="produtos" permissao="visualizar">
            <PropostaRepresentacao />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/produtos/representacao/adicionar",
    lazy: async () => {
      const { default: AddProduto } =
        await import("@/pages/UserGoOn/Representado/components/Projetos/components/AddProduto");
      return {
        element: (
          <ProtectedRoute recurso="produtos" permissao="criar">
            <AddProduto />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/representados",
    lazy: async () => {
      const { default: Representado } =
        await import("@/pages/UserGoOn/Representado");
      return {
        element: (
          <ProtectedRoute recurso="representados" permissao="visualizar">
            <Representado />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/representados/:id/profile",
    lazy: async () => {
      const { default: VehicleProfileEditor } =
        await import("@/pages/UserGoOn/Representado/VehicleProfile");
      return {
        element: (
          <ProtectedRoute recurso="representados" permissao="visualizar">
            <VehicleProfileEditor />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/representantes",
    lazy: async () => {
      const { default: Representante } =
        await import("@/pages/UserGoOn/Representante");
      return {
        element: (
          <ProtectedRoute recurso="representantes" permissao="visualizar">
            <Representante />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/relatorios",
    lazy: async () => {
      const { default: PagePipeline } =
        await import("@/pages/UserGoOn/Pipeline");
      return {
        element: (
          <ProtectedRoute recurso="pipe" permissao="visualizar">
            <PagePipeline />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/vendas",
    lazy: async () => {
      const { default: AreaVendas } =
        await import("@/pages/UserGoOn/AreaDeVendas");
      return {
        element: (
          <ProtectedRoute recurso="area-de-vendas" permissao="visualizar">
            <AreaVendas />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/midia",
    lazy: async () => {
      const { default: AreaMidia } = await import("@/pages/AreaMidia");
      return {
        element: (
          <ProtectedRoute recurso="planejamento-midia" permissao="visualizar">
            <AreaMidia />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/ad-desk-radio",
    lazy: async () => {
      const { default: AdDeskRadio } =
        await import("@/pages/UserGoOn/AdDeskRadio");
      return {
        element: (
          <ProtectedRoute recurso="ad-desk-radio" permissao="visualizar">
            <AdDeskRadio />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/ad-desk-radio/:id",
    lazy: async () => {
      const { default: AdDeskRadioDetails } =
        await import("@/pages/UserGoOn/AdDeskRadio/Details");
      return {
        element: (
          <ProtectedRoute recurso="ad-desk-radio" permissao="visualizar">
            <AdDeskRadioDetails />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/metas",
    lazy: async () => {
      const { default: PageMetas } = await import("@/pages/UserGoOn/Metas");
      return {
        element: (
          <ProtectedRoute recurso="metas" permissao="visualizar">
            <PageMetas />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/negocios-em-aberto",
    lazy: async () => {
      const { default: NegociosEmAberto } =
        await import("@/pages/UserGoOn/JornadaExpansao/NegociosEmAberto");
      return {
        element: (
          <ProtectedRoute
            recurso="overview-relacionamento-de-media"
            permissao="visualizar"
          >
            <NegociosEmAberto />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/negocios-ativos",
    lazy: async () => {
      const { default: NegociosEmAberto } =
        await import("@/pages/UserGoOn/JornadaExpansao/NegociosEmAberto");
      return {
        element: (
          <ProtectedRoute
            recurso="overview-relacionamento-de-media"
            permissao="visualizar"
          >
            <NegociosEmAberto />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/nao-midia/negocios-em-aberto",
    lazy: async () => {
      const { default: NegociosNaoMidiaExpanded } =
        await import("@/pages/UserGoOn/JornadaExpansao/NegociosNaoMidiaExpanded");
      return {
        element: (
          <ProtectedRoute recurso="overview-negocios" permissao="visualizar">
            <NegociosNaoMidiaExpanded />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/nao-midia/negocios-ativos",
    lazy: async () => {
      const { default: NegociosNaoMidiaExpanded } =
        await import("@/pages/UserGoOn/JornadaExpansao/NegociosNaoMidiaExpanded");
      return {
        element: (
          <ProtectedRoute recurso="overview-negocios" permissao="visualizar">
            <NegociosNaoMidiaExpanded />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/prospeccoes",
    lazy: async () => {
      const { default: PageProspeccao } =
        await import("@/pages/UserGoOn/Prospeccoes");
      return {
        element: (
          <ProtectedRoute recurso="prospeccoes" permissao="visualizar">
            <PageProspeccao />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/prospeccoes/:idProspect",
    lazy: async () => {
      const { default: ProspeccaoPage } =
        await import("@/pages/UserGoOn/Prospeccoes/ProspeccaoPage");
      return {
        element: (
          <ProtectedRoute recurso="prospeccoes" permissao="visualizar">
            <ProspeccaoPage />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/products",
    lazy: async () => {
      const { default: ProdutosCriacao } =
        await import("@/pages/UserGoOn/ProdutosCriacao/ProdutosCriacao");
      return {
        element: (
          <ProtectedRoute recurso="produtos" permissao="visualizar">
            <ProdutosCriacao />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/formatos",
    lazy: async () => {
      const { default: FormatosCriacao } =
        await import("@/pages/UserGoOn/Formatos/FormatosCriacao");
      return {
        element: (
          <ProtectedRoute recurso="formatos" permissao="visualizar">
            <FormatosCriacao />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/jobs",
    lazy: async () => {
      const { default: ListagemJobs } =
        await import("@/pages/UserGoOn/Jobs/ListagemJobs");
      return {
        element: (
          <ProtectedRoute recurso="jobs" permissao="visualizar">
            <ListagemJobs />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/empresas",
    lazy: async () => {
      const { default: ListagemEmpresas } =
        await import("@/pages/UserGoOn/Empresas/ListagemEmpresas");
      return {
        element: (
          <ProtectedRoute recurso="empresas" permissao="visualizar">
            <ListagemEmpresas />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/empresas/produtos/criacao/:id",
    lazy: async () => {
      const { default: ListagemProdutos } =
        await import("@/pages/UserGoOn/Empresas/Produtos/ListagemProdutos");
      return {
        element: (
          <ProtectedRoute recurso="empresas" permissao="visualizar">
            <ListagemProdutos />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/campanhas",
    lazy: async () => {
      const { default: ListagemCampanhas } =
        await import("@/pages/UserGoOn/Campanhas/ListagemCampanhas");
      return {
        element: (
          <ProtectedRoute recurso="campanhas" permissao="visualizar">
            <ListagemCampanhas />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/controller",
    lazy: async () => {
      const { default: JornadaController } =
        await import("@/pages/UserGoOn/JornadaController/JornadaController");
      return {
        element: (
          <ProtectedRoute recurso="controller" permissao="visualizar">
            <JornadaController />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/ad-desk-pay-financeiro",
    lazy: async () => {
      const { AdDeskPay } = await import("@/pages/UserGoOn/AdDeskPay");
      return {
        element: (
          <ProtectedRoute recurso="ad-desk-pay" permissao="visualizar">
            <AdDeskPay />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/controller/dre",
    lazy: async () => {
      const { default: PageDre } =
        await import("@/pages/UserGoOn/JornadaController/DRE/index");
      return {
        element: (
          <ProtectedRoute recurso="controller" permissao="visualizar">
            <PageDre />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/empresas/produtos/controller/:id_empresa",
    lazy: async () => {
      const { default: ListagemProdutosController } =
        await import("@/pages/UserGoOn/Empresas/ProdutosPeformance/ListagemProdutos");
      return {
        element: (
          <ProtectedRoute recurso="empresas" permissao="visualizar">
            <ListagemProdutosController />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/empresas/produtos/controller/:id_empresa/:id_produto",
    lazy: async () => {
      const { default: ListagemCanaisController } =
        await import("@/pages/UserGoOn/Empresas/ProdutosPeformance/ListagemCanal");
      return {
        element: (
          <ProtectedRoute recurso="empresas" permissao="visualizar">
            <ListagemCanaisController />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/empresas/produtos/controller/:id_empresa/:id_produto/:id_canal",
    lazy: async () => {
      const { default: ListagemFormatos } =
        await import("@/pages/UserGoOn/Empresas/ProdutosPeformance/ListagemFormatos");
      return {
        element: (
          <ProtectedRoute recurso="empresas" permissao="visualizar">
            <ListagemFormatos />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/empresas/produtos/controller/:id_empresa/:id_produto/:id_canal/:id_formato",
    lazy: async () => {
      const { default: ListagemModelosCompra } =
        await import("@/pages/UserGoOn/Empresas/ProdutosPeformance/ListagemModelosCompra");
      return {
        element: (
          <ProtectedRoute recurso="empresas" permissao="visualizar">
            <ListagemModelosCompra />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/contatos/adicionar2",
    lazy: async () => {
      const { default: FormCadastroPage } =
        await import("@/pages/UserGoOn/Users/FormCadastroPage");
      return {
        element: (
          <ProtectedRoute recurso="contatos" permissao="criar">
            <FormCadastroPage />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/campanhas-performance",
    lazy: async () => {
      const { default: ListagemCampanhasPeformace } =
        await import("@/pages/UserGoOn/CampanhasPeformace/ListagemCampanhasPeformace");
      return {
        element: (
          <ProtectedRoute recurso="campanhas" permissao="visualizar">
            <ListagemCampanhasPeformace />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/painel-campanhas",
    lazy: async () => {
      const { default: PainelCampanhas } =
        await import("@/pages/UserGoOn/PainelCampanhas/PainelCampanhas");
      return {
        element: (
          <ProtectedRoute
            recurso="campanhas-publicitarias"
            permissao="visualizar"
          >
            <PainelCampanhas />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/fornecedores",
    lazy: async () => {
      const { default: ListagemFornecedores } =
        await import("@/pages/UserGoOn/Fornecedores/ListagemFornecedores");
      return {
        element: (
          <ProtectedRoute recurso="fornecedores" permissao="visualizar">
            <ListagemFornecedores />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/fornecedores/configs",
    lazy: async () => {
      const { default: ConfiguracoesFornecedores } =
        await import("@/pages/UserGoOn/Fornecedores/Configuracoes");
      return {
        element: (
          <ProtectedRoute recurso="fornecedores" permissao="visualizar">
            <ConfiguracoesFornecedores />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/fornecedores/produtos",
    lazy: async () => {
      const { default: PropostaFornecedores } =
        await import("@/pages/UserGoOn/Fornecedores/Proposta/Proposta");
      return {
        element: (
          <ProtectedRoute recurso="fornecedores" permissao="visualizar">
            <PropostaFornecedores />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/empresas-fornecedores",
    lazy: async () => {
      const { default: FornecedoresEmpresa } =
        await import("@/pages/UserGoOn/FornecedoresEmpresa/FornecedoresEmpresa");
      return {
        element: (
          <ProtectedRoute
            recurso="fornecedores-empresas"
            permissao="visualizar"
          >
            <FornecedoresEmpresa />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/notas-fiscais",
    lazy: async () => {
      const { default: ListNotasFiscais } =
        await import("@/pages/UserGoOn/NotasFiscais/ListNotasFiscais");
      return {
        element: (
          <ProtectedRoute recurso="notas-fiscais" permissao="visualizar">
            <ListNotasFiscais />
          </ProtectedRoute>
        ),
      };
    },
  },
  // ─── Carteirização ─────────────────────────────────────────────────────────
  {
    path: "/carteirizacao",
    lazy: async () => {
      const { default: Carteirizacao } =
        await import("@/pages/UserGoOn/Carteirizacao");
      return {
        element: (
          <ProtectedRoute recurso="carteiras" permissao="visualizar">
            <Carteirizacao />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/carteirizacao/nova",
    lazy: async () => {
      const { default: NovaCarteira } =
        await import("@/pages/UserGoOn/Carteirizacao/Nova");
      return {
        element: (
          <ProtectedRoute recurso="carteiras" permissao="criar">
            <NovaCarteira />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/carteirizacao/configuracoes",
    lazy: async () => {
      const { default: CarteiraConfigs } =
        await import("@/pages/UserGoOn/Carteirizacao/Configuracoes");
      return {
        element: (
          <ProtectedRoute recurso="carteiras" permissao="editar">
            <CarteiraConfigs />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/carteirizacao/:id",
    lazy: async () => {
      const { default: CarteiraDetalhe } =
        await import("@/pages/UserGoOn/Carteirizacao/Detalhe");
      return {
        element: (
          <ProtectedRoute recurso="carteiras" permissao="visualizar">
            <CarteiraDetalhe />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/carteirizacao/:id/montar",
    lazy: async () => {
      const { default: MontarCarteira } =
        await import("@/pages/UserGoOn/Carteirizacao/Montar");
      return {
        element: (
          <ProtectedRoute recurso="carteiras" permissao="editar">
            <MontarCarteira />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/painel-senhas",
    lazy: async () => {
      const { PainelSenhasAtendente } =
        await import("@/pages/UserGoOn/PainelSenhas/Atendente");
      return {
        element: (
          <ProtectedRoute recurso="painel-senhas" permissao="visualizar">
            <PainelSenhasAtendente />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/painel-senhas/configuracoes",
    lazy: async () => {
      const { PainelSenhasConfiguracoes } =
        await import("@/pages/UserGoOn/PainelSenhas/Configuracoes");
      return {
        element: (
          <ProtectedRoute recurso="painel-senhas" permissao="visualizar">
            <PainelSenhasConfiguracoes />
          </ProtectedRoute>
        ),
      };
    },
  },
  {
    path: "/cronograma",
    lazy: async () => {
      const { default: PlanejamentoRedes } =
        await import("@/pages/UserGoOn/PlanejamentoRedes");
      return {
        element: (
          <ProtectedRoute recurso="cronograma-social" permissao="visualizar">
            <PlanejamentoRedes />
          </ProtectedRoute>
        ),
      };
    },
  },
];
export default RoutesUserGoon;
